import React from 'react';
import { RouteObject } from 'react-router-dom';
import { ApiClient } from 'spry-react/utils/apiClient';
import { TwoFactorAuthPage } from './twoFactorAuthPage';

export function loginRoutes(loaderApiClient: ApiClient): RouteObject[] {
  return [
    {
      path: "login",
      children: [
        {
          index: true,
          lazy: async() => {
            const { LoginPage } = await import('./loginPage');
            return {
              element: <LoginPage />
            }
          }
        },
        {
          path: "verify",
          lazy: async () => {
            const { loader, TwoFactorAuthPage } = await import('./twoFactorAuthPage');
            return {
              element: <TwoFactorAuthPage />,
              loader: () => loader(loaderApiClient)
            }
          }
        },
      ]
    },
    {
      path: "forgotPassword",
      lazy: async () => {
        const { loader, ForgotPasswordPage  } = await import('./forgotPasswordPage');
        return {
          element: <ForgotPasswordPage />,
          loader: () => loader(loaderApiClient),
        };
      },
    }
  ];
}

export class LoginUrls
{
  public static login() {
    return "/login"
  }
  public static forgotPassword() {
    return "/forgotPassword"
  }
  public static settings() {
    return "/account";
  }
  public static twoFactorVerification(returnUrl: string | null) {
    if (returnUrl) {
      return `/login/verify?ReturnUrl=${encodeURIComponent(returnUrl)}`;
    }
    return "/login/verify"
  }
}

